import React, { useState } from "react";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
  Typography,
  IconButton,
  Card,
  Menu,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import { AgChartsReact } from "ag-charts-react";
import DeleteConfirmation from "../DeleteConfirmation";

function roundToTwoDecimal(number) {
  return Math.ceil(number * 100) / 100;
}

function Widget2(props) {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [show, setShow] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    //setDeleteDialog(false)
  };
  const handleDeleteClose = () => {
    setDeleteDialog(false);
  };
  const budgetValue = Object.values(props.categoryBudget.budgetValues);
  const actualValue = Object.values(props.categoryBudget.actualValues);

  const categoryTotal = budgetValue.reduce((a, b) => a + b, 0);
  const categorySpantTotal = actualValue.reduce((a, b) => a + b, 0);

  const [options, setOptions] = useState({
    autoSize: true,
    theme: {
      baseTheme: "ag-default-dark",
      overrides: {
        line: {
          background: {
            fill: "#2A2E32",
          },
        },
      },
    },
    data: [
      {
        month: "Jan",
        budget: props.categoryBudget?.budgetValues.JANUARY,
        actualValue: props.categoryBudget?.actualValues.JANUARY,
      },
      {
        month: "Feb",
        budget: props.categoryBudget?.budgetValues.FEBRUARY,
        actualValue: props.categoryBudget?.actualValues.FEBRUARY,
      },
      {
        month: "Mar",
        budget: props.categoryBudget?.budgetValues.MARCH,
        actualValue: props.categoryBudget?.actualValues.MARCH,
      },
      {
        month: "Apr",
        budget: props.categoryBudget?.budgetValues.APRIL,
        actualValue: props.categoryBudget?.actualValues.APRIL,
      },
      {
        month: "May",
        budget: props.categoryBudget?.budgetValues.MAY,
        actualValue: props.categoryBudget?.actualValues.MAY,
      },
      {
        month: "Jun",
        budget: props.categoryBudget?.budgetValues.JUNE,
        actualValue: props.categoryBudget?.actualValues.JUNE,
      },
      {
        month: "Jul",
        budget: props.categoryBudget?.budgetValues.JULY,
        actualValue: props.categoryBudget?.actualValues.JULY,
      },
      {
        month: "Aug",
        budget: props.categoryBudget?.budgetValues.AUGUST,
        actualValue: props.categoryBudget?.actualValues.AUGUST,
      },
      {
        month: "Sep",
        budget: props.categoryBudget?.budgetValues.SEPTEMBER,
        actualValue: props.categoryBudget?.actualValues.SEPTEMBER,
      },
      {
        month: "Oct",
        budget: props.categoryBudget?.budgetValues.OCTOBER,
        actualValue: props.categoryBudget?.actualValues.OCTOBER,
      },
      {
        month: "Nov",
        budget: props.categoryBudget?.budgetValues.NOVEMBER,
        actualValue: props.categoryBudget?.actualValues.NOVEMBER,
      },
      {
        month: "Dec",
        budget: props.categoryBudget?.budgetValues.DECEMBER,
        actualValue: props.categoryBudget?.actualValues.DECEMBER,
      },
    ],
    series: [
      {
        xKey: "month",
        yKey: "budget",
      },
      {
        xKey: "month",
        yKey: "actualValue",
      },
    ],
    legend: {
      position: "bottom",
    },
  });

  const handleDeleteConfirmation = () => {
    setDeleteDialog(true);
  };

  return (
    <>
      <Card
        className="relative flex flex-col flex-auto rounded-2xl shadow overflow-hidden"
        onClick={() => {
          props.setTableName(props.categoryName);
          props.handleChange();
        }}
      >
        <div className="p-24 pr-12 pb-12">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <Typography
                variant="body1"
                className="text-lg font-medium tracking-tight leading-6 truncate"
              >
                {props.categoryName}
              </Typography>
            </div>
            <div className="-mt-8">
              <IconButton onClick={() => setShow((prev) => !prev)}>
                <FuseSvgIcon>material-twotone:keyboard_arrow_down</FuseSvgIcon>
              </IconButton>
              <IconButton
                onClick={handleClick}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <FuseSvgIcon>heroicons-outline:dots-vertical</FuseSvgIcon>
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    props.setTableName(props.categoryName);
                    props.handleChange();
                  }}
                >
                  See All {props.categoryName}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    props.openEdit(true);
                    props.openDialog(true);
                    props.setCategoryName(props.categoryName);
                    props.setNewCategory(props.categoryName)
                    props.setCategoryId(props.categoryId);
                  }}
                >
                  Update
                </MenuItem>
                <MenuItem onClick={handleDeleteConfirmation}>Delete</MenuItem>
              </Menu>
            </div>
          </div>
          <div className="flex flex-row flex-wrap mt-16 -mx-24">
            <div className="flex flex-col mx-24 my-12">
              <Typography className="text-sm font-medium leading-none">
                Total
              </Typography>
              <Typography className="mt-8 font-medium text-3xl leading-none">
                €{roundToTwoDecimal(categoryTotal)}
              </Typography>
            </div>
            <div className="flex flex-col mx-24 my-12">
              <Typography className="text-sm font-medium leading-none">
                Spent
              </Typography>
              <Typography className="mt-8 font-medium text-3xl leading-none">
                €{roundToTwoDecimal(categorySpantTotal)}
              </Typography>
            </div>
          </div>
        </div>
        {show && (
          <div className="w-100-p">
            <AgChartsReact options={options} />
          </div>
        )}
      </Card>
      <DeleteConfirmation
        open={deleteDialog}
        handleDeleteClose={handleDeleteClose}
        onYes={() => props.handleDelete(props.categoryId)}
        title={`Are you sure you want to delete ${props.categoryName}?`}
        message={`This will delete ${props.categoryName} permanently. You can not undo this action.`}
      />
    </>
  );
}

export default React.memo(Widget2);
